export default {
  lazyLoadOffset: 800
}
